/* ==========================================================================
   Sound module.

   The toy has two press-points and one speaker: pressing the tummy again while
   it is singing moves to the NEXT song, and pressing the hand starts meditation
   mode. This mirrors that exactly — a press-point with several tracks advances
   through them, and the press after the last one stops. So the page behaves the
   way the object in the box behaves, which is the whole point of the section.

   One <audio> element, src swapped. Not one element per track: iOS unlocks
   playback per ELEMENT on a user gesture, so an element that first meets a
   src outside a gesture can never play. Swapping the src on the element the
   user already tapped keeps every later track playable.

   With this file blocked the photo, the labels and the track list all still
   render; the buttons simply do nothing.
   ========================================================================== */
(function () {
  'use strict';

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function init(root) {
    var audio = root.querySelector('[data-cs-audio]');
    /* Once per module: the snippet can print this script twice on one page. */
    if (!audio || root.csSoundPlayFirst) return;

    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-cs-spot]'));
    var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-cs-track]'));
    var now = root.querySelector('[data-cs-now]');
    var nowTitle = root.querySelector('[data-cs-nowtitle]');
    var nowTime = root.querySelector('[data-cs-nowtime]');
    var bar = root.querySelector('[data-cs-bar]');
    var stopBtn = root.querySelector('[data-cs-stop]');

    /* tracks grouped by the spot they belong to. The button's data-cs-track is
       "<spotIndex>:<trackIndex>", written by Liquid from the same loop that
       wrote the spots, so the two surfaces cannot fall out of step. */
    var bySpot = {};
    tracks.forEach(function (btn) {
      var parts = (btn.getAttribute('data-cs-track') || '').split(':');
      var s = parts[0];
      (bySpot[s] = bySpot[s] || []).push(btn);
    });

    var current = null; // the track button that is playing

    function paint() {
      spots.concat(tracks).forEach(function (el) {
        var on = false;
        if (current) {
          if (el.hasAttribute('data-cs-track')) {
            on = el === current;
          } else {
            on = el.getAttribute('data-cs-spot') === current.getAttribute('data-cs-track').split(':')[0];
          }
        }
        el.classList.toggle('is-playing', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (current) {
        nowTitle.textContent = current.getAttribute('data-cs-title') || '';
        now.hidden = false;
      } else {
        now.hidden = true;
        if (bar) bar.style.width = '0';
        if (nowTime) nowTime.textContent = '0:00';
      }
    }

    function stop() {
      audio.pause();
      try { audio.currentTime = 0; } catch (e) { /* not seekable yet */ }
      current = null;
      paint();
    }

    function play(btn) {
      var src = btn.getAttribute('data-cs-src');
      if (!src) return;
      /* Assigning the same src again would restart the download on some
         browsers; only touch it when it actually changes. */
      if (audio.getAttribute('src') !== src) audio.setAttribute('src', src);
      audio.loop = btn.hasAttribute('data-cs-loop');
      try { audio.currentTime = 0; } catch (e) {}
      current = btn;
      paint();
      var p = audio.play();
      /* A rejected play() (autoplay policy, a missing file) must not leave the
         UI claiming to be playing. */
      if (p && typeof p.catch === 'function') {
        p.catch(function () { if (current === btn) { current = null; paint(); } });
      }
    }

    /* A press-point: start its first track; press it again while it is
       sounding and it stops. It used to advance to the next song (the toy's own
       behaviour), but the dot shows a pause glyph while playing and shoppers
       read a press on it as "pause" (Clarity, 27 Oct: dead/rage taps on the
       dot). The track list below still picks any song, and a finished track
       still rolls on to the next one. */
    function toggleSpot(i) {
      var list = bySpot[String(i)] || [];
      if (!list.length) return;
      if (list.indexOf(current) > -1) stop();
      else play(list[0]);
    }

    spots.forEach(function (spot) {
      spot.addEventListener('click', function () {
        toggleSpot(spot.getAttribute('data-cs-spot'));
      });
    });

    /* The whole picture is pressable, not only the round buttons: the photo was
       the most-tapped thing in this block and did nothing. A label plays its own
       point; anywhere else on the toy plays the first point (the tummy). */
    var frame = root.querySelector('.cs-sound__frame');
    var firstSpot = spots.length ? spots[0].getAttribute('data-cs-spot') : null;
    if (frame && firstSpot !== null) {
      frame.addEventListener('click', function (e) {
        if (e.target.closest('.cs-sound__spot')) return;
        var tag = e.target.closest('[data-cs-tag]');
        toggleSpot(tag ? tag.getAttribute('data-cs-tag') : firstSpot);
      });
    }

    /* For the "Hear him chant" button near the price: start the first point
       without toggling it off. Called inside that button's click, so the
       user gesture still unlocks audio on iOS. */
    root.csSoundPlayFirst = function () {
      var list = bySpot[String(firstSpot)] || [];
      if (list.length && list.indexOf(current) === -1) play(list[0]);
    };

    /* A named track in the list: play it, or stop it if it is the one playing. */
    tracks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (current === btn) stop();
        else play(btn);
      });
    });

    if (stopBtn) stopBtn.addEventListener('click', stop);

    audio.addEventListener('timeupdate', function () {
      if (!current) return;
      if (nowTime) nowTime.textContent = fmt(audio.currentTime);
      if (bar && audio.duration && isFinite(audio.duration)) {
        bar.style.width = (audio.currentTime / audio.duration * 100) + '%';
      }
    });

    /* End of a track inside a multi-track point rolls on to the next, so the
       three songs play as a set if you leave it alone. A looping track never
       fires this. */
    audio.addEventListener('ended', function () {
      if (!current) return;
      var list = bySpot[current.getAttribute('data-cs-track').split(':')[0]] || [];
      var at = list.indexOf(current);
      if (at > -1 && at + 1 < list.length) play(list[at + 1]);
      else stop();
    });

    audio.addEventListener('error', stop);

    /* Sound that follows you down the page is the fastest way to make someone
       leave. Stop when the section is fully out of view, and when the tab goes
       away. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting && current) stop();
      }, { threshold: 0 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && current) stop();
    });

    /* Two sound modules on one page must not talk over each other. */
    root.addEventListener('cs:sound-play', function () {});
    document.addEventListener('cs:sound-start', function (e) {
      if (e.detail !== root && current) stop();
    });
    audio.addEventListener('play', function () {
      document.dispatchEvent(new CustomEvent('cs:sound-start', { detail: root }));
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-cs-sound]').forEach(init);
    /* The shortcut is invisible until a player exists, so it is never dead. */
    /* .cs-sound, not the bare attribute: cs-gallery-video.js sets data-cs-sound on a <video> once its sound is on. */
    var first = document.querySelector('.cs-sound[data-cs-sound]');
    if (first && first.csSoundPlayFirst) {
      document.querySelectorAll('[data-cs-hear]').forEach(function (b) { b.classList.add('is-ready'); });
    }
  }

  /* [data-cs-hear] — a shortcut above the fold (main-product.liquid, rating row)
     to the player inside the Product details tab: open that tab, start the
     first track, and bring the picture into view. Audio first, while we are
     still inside the tap; the scroll can catch up. */
  if (!window.__csHearBound) document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cs-hear]');
    if (!btn) return;
    var root = document.querySelector('.cs-sound[data-cs-sound]');
    if (!root || !root.csSoundPlayFirst) return;
    e.preventDefault();
    var panel = root.closest('[role="tabpanel"]');
    var tab = panel && document.querySelector('[aria-controls="' + panel.id + '"]');
    if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
    root.csSoundPlayFirst();
    var target = root.querySelector('.cs-sound__frame') || root;
    var bar = document.querySelector('[data-cs-tabbar]');
    /* Clear whatever is pinned at the top now (offer strip + header) plus the
       sticky tab bar, so the toy's head is not under them. */
    var pinned = document.querySelector('.section-header') || document.querySelector('.cs-tier-sec, .cs-tier');
    var off = (bar ? bar.offsetHeight : 0) + (pinned ? Math.max(0, pinned.getBoundingClientRect().bottom) : 0) + 8;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + target.getBoundingClientRect().top - off), behavior: reduce ? 'auto' : 'smooth' });
  });
  window.__csHearBound = true;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
